// extracted by mini-css-extract-plugin
export default {"row":"ImageLabel_row__sE8Wu","image_container":"ImageLabel_image_container__rDaKY","image":"ImageLabel_image__1vxQo"};